import * as tslib_1 from "tslib";
import NewFolderMenuItem from './NewFolderMenuItem';
import setIsFocusInSearchBox from '../actions/setIsFocusInSearchBox';
import setMoveToFindText from '../actions/setMoveToFindText';
import setShouldShowAllFolders from '../actions/setShouldShowAllFolders';
import datapoints from '../datapoints';
import resetNewFolderViewState from '../mutators/resetNewFolderViewState';
import setInitialNewFolderViewState from '../mutators/setInitialNewFolderViewState';
import moveToStore from '../store/store';
import getFolderNameToCountMap from '../utils/getFolderNameToCountMap';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import { resetFocus } from 'owa-mail-focus-manager';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { SearchBox, } from 'office-ui-fabric-react/lib/SearchBox';
import { FocusZone, FocusZoneDirection, } from 'office-ui-fabric-react/lib/FocusZone';
var styles = require('./MoveToFolder.scss');
var classNames = require('classnames/bind').bind(styles);
var DEFAULT_MAX_FOLDERS = 8;
var MoveToFolder = /** @class */ (function (_super) {
    tslib_1.__extends(MoveToFolder, _super);
    function MoveToFolder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.focusOnSearchBox = function () {
            window.requestAnimationFrame(function () {
                if (_this.searchBoxRef) {
                    _this.searchBoxRef.focus();
                }
            });
        };
        _this.dismissMenu = function () {
            _this.props.dismissMenu();
        };
        _this.onSearchChange = function (findText) {
            setMoveToFindText(findText);
            setShouldShowAllFolders(false);
            resetNewFolderViewState();
        };
        _this.onSearchboxRender = function () {
            return (React.createElement(SearchBox, { key: 'searchMoveTo', className: styles.moveToMenuItemContainerCommon, componentRef: function (ref) {
                    _this.searchBoxRef = ref;
                }, value: moveToStore.findText, labelText: strings.searchFolder, onEscape: _this.onEscapeOnSearchBox, onChange: _this.onSearchChange, onBlur: _this.onBlurOnSearchBox, onFocus: _this.onFocusOnSearchBox, onSearch: _this.onEnterOnSearchBox, getStyles: _this.getSearchBoxStyles }));
        };
        _this.onFocusOnSearchBox = function (evt) {
            setIsFocusInSearchBox(true);
        };
        _this.onBlurOnSearchBox = function (evt) {
            setIsFocusInSearchBox(false);
            _this.onSearchBoxEnterCallback = null;
        };
        _this.onEscapeOnSearchBox = function (evt) {
            // Dismiss the menu when user escapes while focus was on search box.
            // This needs to be handled separately than other menu items
            _this.dismissMenu();
        };
        _this.onEnterOnSearchBox = function (evt) {
            if (_this.onSearchBoxEnterCallback) {
                _this.onSearchBoxEnterCallback();
            }
        };
        _this.onFolderSelect = function (evt, folderId) {
            _this.dismissMenu();
            _this.props.onFolderClick(folderId);
            resetFocus();
            logUsage(datapoints.moveToClickFolder.datapoint.name, datapoints.moveToClickFolder.datapoint.customData(_this.props.actionSource));
        };
        _this.onViewAll = function (evt) {
            // Required so as the menu does not dismiss when view all is clicked.
            // VSO: 22703 - Investigate why preventDefault is required when view all item is clicked in the move to context menu
            evt.stopPropagation();
            evt.preventDefault();
            // Clear the find text when view all is pressed
            setMoveToFindText('');
            resetNewFolderViewState();
            setShouldShowAllFolders(true);
            logUsage(datapoints.moveToViewAllFoldersClicked.datapoint.name, datapoints.moveToViewAllFoldersClicked.datapoint.customData(_this.props.actionSource));
            _this.focusOnSearchBox();
        };
        _this.onCreateNewFolder = function (folderName, moveToNewFolderActionSource) {
            _this.dismissMenu();
            _this.props.createNewFolder(folderName, folderNameToId('msgfolderroot')).then(function (folderId) {
                // VSO - 22606 - Handle waiting state when a new folder is created from move to menu
                _this.props.onFolderClick(folderId);
            });
            logUsage(datapoints.moveToCreateNewFolder.datapoint.name, datapoints.moveToCreateNewFolder.datapoint.customData(_this.props.actionSource, moveToNewFolderActionSource));
        };
        _this.addDividerMenu = function (items, key) {
            items.push(React.createElement("div", { className: styles.moveToMenuDivider }));
        };
        _this.shouldHighlightTopItem = function () {
            return moveToStore.isFocusInSearchBox && moveToStore.findText.length > 0;
        };
        _this.onNewFolderClicked = function (evt) {
            evt.stopPropagation();
            setMoveToFindText('');
            setInitialNewFolderViewState();
        };
        return _this;
    }
    MoveToFolder.prototype.componentDidMount = function () {
        // Focus on search box after component mounts
        this.focusOnSearchBox();
    };
    MoveToFolder.prototype.render = function () {
        return (React.createElement(FocusZone, { direction: FocusZoneDirection.bidirectional, handleTabKey: 1 /* all */, shouldInputLoseFocusOnArrowKey: function (inputElement) {
                // We want the up and down arrow keys on search input element to shift the focus to next and previous element respectively
                // irrespective of the default behavior where FocusZone does not permit it if shifting focus is only doable using Tab keys
                return true;
            } }, this.renderMoveToFolderMenu()));
    };
    MoveToFolder.prototype.renderMoveToFolderMenu = function () {
        var _this = this;
        var items = [];
        var folders = null;
        // Add search box
        if (this.props.shouldShowSearchBox) {
            items.push(this.onSearchboxRender());
        }
        var moveToFolder = { folders: [], hasExactMatch: false };
        var allFolders = this.props.getAllFolders();
        var findText = moveToStore.findText.trim();
        var shouldShowAllFolders = moveToStore.shouldShowAllFolders;
        // reset the onSearchBoxEnter call back
        this.onSearchBoxEnterCallback = null;
        if (shouldShowAllFolders) {
            folders = allFolders;
        }
        else {
            // Only add F/O menu items when there is no find text
            if (!findText && this.props.getFocusedOtherMenuItems) {
                var foItems = this.props.getFocusedOtherMenuItems(styles.nonIconMenuItem, this.dismissMenu // onAfterMenuClicked
                );
                items.push.apply(items, foItems);
                this.addDividerMenu(items, 'moveto_fo_divider');
            }
            moveToFolder = this.props.getFolderSuggestions(findText, DEFAULT_MAX_FOLDERS);
            folders = moveToFolder.folders;
        }
        var isTopItemHighlighted = false;
        // Add folders.
        var folderNameCountMap = getFolderNameToCountMap(folders);
        var _loop_1 = function (i, len) {
            var folder = folders[i];
            var folderId = folder.folderId;
            var folderDisplayName = folder.displayName;
            var folderNameToShow = folderNameCountMap[folderDisplayName.toLowerCase()] > 1 &&
                folderIdToName(folder.parentFolderId) != 'msgfolderroot'
                ? folder.parentFolderDisplayName + '/' + folderDisplayName
                : folderDisplayName;
            var containerClass = void 0;
            // Highlight top item and store the callback
            if (i == 0 && this_1.shouldHighlightTopItem()) {
                containerClass = classNames(styles.highlightItem, styles.moveToMenuItemContainer);
                this_1.onSearchBoxEnterCallback = function () {
                    _this.onFolderSelect(null, folderId);
                };
                isTopItemHighlighted = true;
            }
            else {
                containerClass = styles.moveToMenuItemContainer;
            }
            var matchText = '';
            var nonMatchText = folderNameToShow;
            if (findText &&
                folderNameToShow.toLocaleLowerCase().indexOf(findText.toLocaleLowerCase()) == 0) {
                matchText = folderNameToShow.substr(0, findText.length);
                nonMatchText = folderNameToShow.substr(findText.length, folderNameToShow.length - 1);
            }
            items.push(React.createElement("div", { key: 'moveTo' + folderId, role: 'menuitemcheckbox', "data-is-focusable": true, className: containerClass, onClick: function (evt) { return _this.onFolderSelect(evt, folderId); }, title: folderNameToShow },
                React.createElement(Icon, { className: styles.icon, iconName: this_1.props.getCustomIcon
                        ? this_1.props.getCustomIcon(folderId, true)
                        : null }),
                React.createElement("div", { className: styles.folderName },
                    React.createElement("span", { className: styles.folderMatchSuggestion }, matchText),
                    React.createElement("span", { className: styles.folderSuggestion }, nonMatchText))));
        };
        var this_1 = this;
        for (var i = 0, len = folders.length; i < len; i++) {
            _loop_1(i, len);
        }
        // Add extended menus
        // Add divider if we are showing more than 1 (Search Box) items
        if (items.length > 1) {
            this.addDividerMenu(items, 'moveto_extendedMenu_divider');
        }
        // Add create new menu when user had typed something but we could not find an exact match for it
        // Else add the new folder item
        if (findText && !moveToFolder.hasExactMatch) {
            this.addCreateNewMenu(items, isTopItemHighlighted);
        }
        else {
            this.addNewFolderMenu(items);
        }
        // Add All folder menu if we are not already showing all folders and we have more to show.
        if (!moveToStore.shouldShowAllFolders && folders.length < allFolders.length) {
            items.push(React.createElement("div", { className: styles.nonIconMenuItem, "data-is-focusable": true, key: 'moveToViewAll', onClick: this.onViewAll }, strings.allFolders));
        }
        return items;
    };
    MoveToFolder.prototype.addCreateNewMenu = function (items, isTopItemHighlighted) {
        var _this = this;
        // Add create new menu when user had typed something but we could not find an exact match for it
        var containerClass;
        // Highlight create new, store callback, if nothing is highlighted and we can still highlight
        if (!isTopItemHighlighted && this.shouldHighlightTopItem()) {
            containerClass = classNames(styles.highlightItem, styles.moveToMenuItemContainer);
            this.onSearchBoxEnterCallback = function () {
                _this.onCreateNewFolder(moveToStore.findText, 'SearchBoxEnter');
            };
        }
        else {
            containerClass = styles.moveToMenuItemContainer;
        }
        items.push(React.createElement(NewFolderMenuItem, { key: 'createNewFolder', containerClass: containerClass, isEditMode: false, createNew: this.onCreateNewFolder }));
        this.addDividerMenu(items, 'moveto_createNewMenu_divider');
    };
    MoveToFolder.prototype.addNewFolderMenu = function (items) {
        if (moveToStore.newFolderViewState) {
            items.push(React.createElement(NewFolderMenuItem, { key: 'newFolder_Edit', isEditMode: true, createNew: this.onCreateNewFolder }));
        }
        else {
            items.push(React.createElement("div", { key: 'newFolder', className: styles.moveToMenuItemContainer, "data-is-focusable": true, role: 'menuitem', onClick: this.onNewFolderClicked },
                React.createElement("div", { title: strings.moveToFolderNewFolderTooltipText, className: classNames(styles.nonIconMenuItem) }, strings.moveToFolderNewFolderText)));
        }
        this.addDividerMenu(items, 'moveto_createNewMenu_divider');
    };
    // Gets the custom styles for the search box to
    // disable animation and hiding of the search icon
    // setting the search icon color to neutral primary
    MoveToFolder.prototype.getSearchBoxStyles = function (props) {
        var palette = props.theme.palette;
        return {
            root: [
                {
                    paddingLeft: 0,
                },
            ],
            icon: [
                {
                    opacity: 1,
                    transition: 'none',
                },
            ],
            iconContainer: [
                {
                    width: 30,
                    color: palette.neutralPrimary,
                },
            ],
        };
    };
    MoveToFolder = tslib_1.__decorate([
        observer
    ], MoveToFolder);
    return MoveToFolder;
}(React.Component));
export { MoveToFolder };
/**
 * Called when the move to menu is actually dismissed
 * We clean up the move to store when menu dismisses
 */
function onMenuDismissed() {
    // Clean up store as the menu is dismissed
    setMoveToFindText('');
    setShouldShowAllFolders(false);
    resetNewFolderViewState();
}
export function getMoveToMenuProps(shouldShowSearchBox, actionSource, createNewFolder, dismissMenu, getAllFolders, getFolderSuggestions, onFolderClick, getFocusedOtherMenuItems, getCustomIcon, directionalHint, useTargetWidth, coverTarget) {
    var items = [];
    items.push({
        key: 'MoveToMenuItemDiv',
        onRender: function () { return (React.createElement(MoveToFolder, { actionSource: actionSource, createNewFolder: createNewFolder, dismissMenu: dismissMenu, shouldShowSearchBox: shouldShowSearchBox, getAllFolders: getAllFolders, getFolderSuggestions: getFolderSuggestions, onFolderClick: onFolderClick, getFocusedOtherMenuItems: getFocusedOtherMenuItems, getCustomIcon: getCustomIcon })); },
    });
    var menuClassNames = classNames('customScrollBar', styles.moveToMenu);
    var moveToFolderContextMenuProps = {
        className: menuClassNames,
        coverTarget: coverTarget,
        directionalHint: directionalHint ? directionalHint : 4 /* bottomLeftEdge */,
        directionalHintFixed: true,
        items: items,
        onMenuDismissed: onMenuDismissed,
        shouldFocusOnMount: !shouldShowSearchBox,
        useTargetWidth: useTargetWidth,
        focusZoneProps: {
            // We want the up and down arrow keys on search input element to shift the focus to next and previous element respectively
            // irrespective of the default behavior where FocusZone does not permit it if shifting focus is only doable using Tab keys
            shouldInputLoseFocusOnArrowKey: function (inputElement) { return true; },
        },
        calloutProps: {
            getStyles: function (props) { return ({
                root: {
                    animation: 'none',
                    animationDuration: '0s',
                },
            }); },
        },
    };
    return moveToFolderContextMenuProps;
}
//# sourceMappingURL=MoveToFolder.js.map